import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMG, LOGO_URL } from "@/data/content";

export default function About() {
  return (
    <div data-testid="about-page">
      {/* HERO MISSION */}
      <section style={{ background: "var(--ooe-dark)", color: "var(--ooe-on-dark)" }}>
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12 py-24 lg:py-36">
          <div className="eyebrow mb-6" style={{ color: "rgba(249,248,246,0.65)" }}>About Out of Eden</div>
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-7xl leading-[1.05] max-w-4xl">
            A kitchen built on simplicity, purity and care.
            <em className="not-italic" style={{ color: "#A8C2A2" }}> We believe good food makes us feel good.</em>
          </h1>
          <p className="mt-10 max-w-2xl text-[16px] leading-relaxed" style={{ color: "rgba(249,248,246,0.78)" }}>
            We curate exceptional culinary experiences through thoughtfully
            prepared, nutrient-rich cuisine crafted from the finest ingredients.
            Our mission is to redefine catered dining by blending uncompromising
            quality, sophisticated flavor, and wellness-driven principles. With a
            commitment to sustainability, precision, and elegance, we deliver
            food that not only nourishes but inspires a higher standard of living.
          </p>
        </div>
      </section>

      {/* CHEF */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <div
              className="w-full h-[620px] flex items-center justify-center"
              style={{ background: "#FFFFFF", border: "1px solid var(--ooe-border)" }}
            >
              <img src={LOGO_URL} alt="Out of Eden" className="max-h-[80%] max-w-[80%] object-contain" />
            </div>
          </div>
          <div className="lg:col-span-6 lg:pl-10">
            <div className="eyebrow mb-5">Meet the chef</div>
            <h2 className="font-serif-display text-4xl lg:text-6xl leading-tight" style={{ color: "var(--ooe-ink)" }}>
              Andy.
            </h2>
            <p className="mt-8 text-[16px] leading-relaxed" style={{ color: "var(--ooe-ink-2)" }}>
              My successful experiences working with legends at great
              establishments like Buca, Via Allegro, Ma Maison and The Food
              Dudes helped shape a deep understanding of both refined cuisine
              and exceptional hospitality. Now based in London, I draw on those
              experiences through Out of Eden to bring the same level of care,
              creativity and professionalism into every moment.
            </p>
            <p className="mt-6 text-[16px] leading-relaxed" style={{ color: "var(--ooe-ink-2)" }}>
              Creating memorable meals and elevated dining experiences that make
              every guest feel valued and every event truly special.
            </p>
            <Link to="/contact" className="btn-primary mt-10 inline-flex" data-testid="about-contact-btn">
              Begin a Conversation <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>

      {/* PILLARS */}
      <section className="py-24 lg:py-32" style={{ background: "var(--ooe-bg-2)" }}>
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="eyebrow mb-5">Principles</div>
          <h2 className="font-serif-display text-4xl lg:text-6xl mb-16 max-w-3xl" style={{ color: "var(--ooe-ink)" }}>
            What guides every plate.
          </h2>
          <div className="grid md:grid-cols-3 gap-0" style={{ borderTop: "1px solid var(--ooe-border)" }}>
            {[
              { n: "01", t: "Sourcing", d: "From the great farmers at Trails End to Thomas Brothers Market and everything in between — we love to keep it local." },
              { n: "02", t: "Precision", d: "Classic French and Italian techniques combine refined preparation, attention to detail and solid cooking." },
              { n: "03", t: "Wellness", d: "Nutrient-dense, balanced cooking — refined cuisine that leaves you feeling lighter, not weighed down." },
            ].map((p) => (
              <div
                key={p.n}
                className="py-12 pr-8 md:pl-10"
                style={{ borderBottom: "1px solid var(--ooe-border)", borderRight: "1px solid var(--ooe-border)" }}
                data-testid={`pillar-${p.t.toLowerCase()}`}
              >
                <div className="font-serif-display text-2xl mb-6" style={{ color: "var(--ooe-brand)" }}>{p.n}</div>
                <div className="font-serif-display text-3xl mb-4" style={{ color: "var(--ooe-ink)" }}>{p.t}</div>
                <p className="text-[15px] leading-relaxed" style={{ color: "var(--ooe-ink-2)" }}>{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SOURCING IMAGERY */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
        <div className="grid md:grid-cols-2 gap-8">
          <img src={IMG.mirepoix} alt="" className="w-full h-[480px] object-cover gallery-img" />
          <img src={IMG.rainbow_carrots_wide} alt="" className="w-full h-[480px] object-cover gallery-img" />
        </div>
      </section>
    </div>
  );
}
